import type { RouteLocationNormalized } from 'vue-router';
import type { Store } from 'vuex';
import { currentJwt } from '@/lib/jwt';

export function shouldSkipAccountFetchForMatched(matched: RouteLocationNormalized['matched']): boolean {
  return matched.some((record) => record.meta?.skipAuth);
}

/**
 * Loads account into Vuex when missing so route guards and components can rely on store account.
 * No-ops when the route skips auth, there is no JWT, or account is already loaded.
 */
export async function ensureAccountLoadedOnce(store: Store<unknown>, matched: RouteLocationNormalized['matched']): Promise<void> {
  if (shouldSkipAccountFetchForMatched(matched)) {
    return;
  }

  if (!currentJwt()) {
    return;
  }

  if (store.getters['account/getAccount']) {
    return;
  }

  try {
    await store.dispatch('account/fetchAccountData');
  } catch (error) {
    console.error('Failed to fetch account data during navigation:', error);
  }
}
